'use client';

import { createContext, useContext, ReactNode } from 'react';
export interface AppConfig {
  apiUrl: string;
  landingUrl: string;
  oauth: {
    google: { clientId: string };
    apple: { clientId: string };
  };
}

const ConfigContext = createContext<AppConfig | null>(null);

interface ConfigProviderProps {
  children: ReactNode;
  config: AppConfig;
}

export function ConfigProvider({ children, config }: ConfigProviderProps) {
  return (
    <ConfigContext.Provider value={config}>
      {children}
    </ConfigContext.Provider>
  );
}

export function useConfig() {
  const context = useContext(ConfigContext);
  if (!context) {
    throw new Error('useConfig must be used within a ConfigProvider');
  }
  return context;
}
